// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.
import { environment as defaultEnv } from './environment.default';

/// dev env
// export const environment = {
//   ...defaultEnv,
//   production: false,
//   apiBase: '/v1/pool',
//   enableSignup: true,
//   poolServiceName: 'mabel',
//   poolType: 'multi',
//   latestVersion: '0.11.5',
//   title: 'Abelian Mining Pool',
//   subtitle: 'Federated Mining Pools for Abelian',
//   // loadBalancerApiBase: 'http://127.0.0.1:5000/',
//   loadBalancerApiBase: 'http://3.12.229.185:8081/lb',
//   abelApiBase: 'https://api.abelian.info/v1/',
//   miningScriptHost: 'http://3.12.229.185:8081/abelmining.sh',
//   rigelScriptHost: 'http://3.12.229.185:8081/rigelstats.sh',
//   appVersioningHeader: 'x-app-version',
//   siteBaseUrl: 'http://3.12.229.185:8081',
// };

/// prod env
export const environment = {
  ...defaultEnv,
  production: false,
  apiBase: '/v1/pool',
  enableSignup: true,
  poolServiceName: 'mabel',
  poolType: 'multi',
  latestVersion: '0.11.5',
  title: 'Maxpool.org',
  subtitle: 'Federated Mining Pools for Abelian',
  loadBalancerApiBase: 'https://maxpool.org',
  abelApiBase: 'https://api.abelian.info/v1/',
  cpuMiningScriptHost: 'https://download.abelian.info/release/pool/abe-mining-cpu-client.sh',
  miningScriptHost: 'https://download.abelian.info/release/pool/abelminingscript.sh',
  rigelScriptHost: 'https://download.abelian.info/release/pool/rigelstats.sh',
  appVersioningHeader: 'x-app-version',
  siteBaseUrl: 'https://maxpool.org',
  macAmd64DownloadURL: 'https://download.pqabelian.io/release/pool/abelminer-cpu-macos-amd64-v0.13.1.tar.gz',
  macArm64DownloadURL: 'https://download.pqabelian.io/release/pool/abelminer-cpu-macos-arm64-v0.13.1.tar.gz',
  windowsDownloadURL: 'https://download.pqabelian.io/release/pool/abelminer-cpu-windows-amd64-v0.13.1.zip',
};
